module.exports = __webpack_public_path__ + "img/google-img3.2011e903.svg";